import { Box, Stack, Typography, Container } from '@mui/material';

import { MainLayout } from '@modules/Dashboard/components/Layout/MainLayout';
import { AltLogoText } from '@shared/components/Logo/AltLogoText';
import { Steps } from '@modules/Dashboard/partials/Steps';


export const Dashboard = () => {
  return (
    <MainLayout>
      <Box component={Container} maxWidth="lg" py={8} px={2}>
        <Stack spacing={2} alignItems="center" textAlign="center">
          <Typography variant="h1" fontWeight="bold">
            Welcome to <AltLogoText/>.
          </Typography>
          <Typography variant="h4" color="textSecondary" fontWeight={300}>
            Before you begin forging stories, set the foundation.
          </Typography>
        </Stack>
        <Steps/>
      </Box>
    </MainLayout>
  );
};